import React from 'react';

const LoadingSpinner = () => (
    <div className="text-center spacer-2-blocks loading-spinner-overlay">
        <span className="spinner large active center-loading-spinner" />
    </div>
);

export default LoadingSpinner;
